import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.99918 0.833374C11.4393 0.833374 12.871 1.34542 13.9565 2.22539C14.937 3.02029 15.6364 4.12147 15.7618 5.41713C15.7895 5.73449 15.7871 6.05424 15.7859 6.37382L15.7858 6.71112C15.7871 6.93585 15.7923 7.16021 15.8086 7.38355C16.0288 8.46929 16.4874 9.37539 17.1552 10.1239C17.407 10.5126 17.5518 10.9593 17.5744 11.4201C17.5887 12.2341 17.379 12.8842 16.9542 13.3966C16.3579 14.0123 15.5537 14.3941 14.6915 14.4725C11.5903 14.8051 8.47494 14.8051 5.3771 14.4728C4.5145 14.3909 3.71013 14.0092 3.11054 13.3958C2.70463 12.8956 2.48817 12.272 2.5005 11.632C2.52502 10.9938 2.66342 10.5195 2.92183 10.1123C3.59083 9.36868 4.0491 8.4652 4.25103 7.49244C4.26843 6.69079 4.26737 6.04943 4.32212 5.4224C4.44388 4.12349 5.13695 3.02542 6.10383 2.23123C7.1782 1.34876 8.59311 0.833374 9.99918 0.833374Z",
      stroke: "#1D2522",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.46863 17.7983C8.02338 18.4946 8.83803 18.9453 9.73229 19.0505C10.6265 19.1557 11.5267 18.9069 12.2334 18.359C12.4508 18.197 12.6464 18.0086 12.8156 17.7983",
      stroke: "#1D2522",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }